// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, .cvx-header-container .cvx-header-menu .cvx-header-menu-item a span, .cvx-header-container .cvx-header-application span {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

.cvx-header-container {
  display: grid;
  grid-template-columns: 400px auto 400px;
  grid-auto-flow: column;
  height: 100%;
  background-color: #ffffff;
}
.cvx-header-container .cvx-header-menu {
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  padding-left: 1rem;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 40px;
  text-decoration: none;
  height: 40px;
  border-radius: 13px;
  padding-left: 0px;
  padding-right: 0px;
  min-width: 50px;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a ::ng-deep .mdc-button__label {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a i {
  font-size: 1.375rem;
  font-weight: 900;
}
.cvx-header-container .cvx-header-menu .cvx-header-menu-item a span {
  margin-top: 2px;
  font-size: 0.75rem;
}
.cvx-header-container .cvx-header-application {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.cvx-header-container .cvx-header-application img {
  width: 3.2rem;
  cursor: pointer;
}
.cvx-header-container .cvx-header-application span {
  margin-top: 0.5rem;
  color: #009dd9;
  font-size: 1.375rem;
  cursor: default;
}
.cvx-header-container .cvx-header-profile {
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  padding-left: 1rem;
  padding-right: 1rem;
  float: right;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
